var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLeftOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77778 18.0747C3.28889 18.0747 2.87037 17.9006 2.52222 17.5525C2.17407 17.2043 2 16.7858 2 16.2969V3.85248C2 3.3636 2.17407 2.94508 2.52222 2.59693C2.87037 2.24878 3.28889 2.07471 3.77778 2.07471H16.2222C16.7111 2.07471 17.1296 2.24878 17.4778 2.59693C17.8259 2.94508 18 3.3636 18 3.85248V16.2969C18 16.7858 17.8259 17.2043 17.4778 17.5525C17.1296 17.9006 16.7111 18.0747 16.2222 18.0747H3.77778ZM6.44444 16.2969V3.85248H3.77778V16.2969H6.44444ZM8.22222 16.2969H16.2222V3.85248H8.22222V16.2969Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLeftOutline);
export default __webpack_public_path__ + "static/media/Sidebar_Left_Outline.ab446c3f59b1772a9e63fd3804292a5a.svg";
export { ForwardRef as ReactComponent };